class CartSubscriptionUpsell {
  constructor() {
    document.addEventListener('change', this.#onChange);
    document.addEventListener('click', this.#onToggleClick);
  }

  #onChange = (event) => {
    const input = event.target;
    if (!input.matches('[data-cart-upsell-input]')) return;
    if (!input.checked) return;
    this.#handleUpsellChange(input);
  };

  #onToggleClick = (event) => {
    const toggle = event.target.closest('[data-upsell-toggle]');
    if (!toggle) return;

    const opt = toggle.closest('.cart-upsell__opt--sub');
    if (!opt) return;

    const details = opt.querySelector('[data-upsell-details]');
    if (!details) return;

    const open = !details.classList.contains('is-open');
    details.classList.toggle('is-open', open);
    toggle.classList.toggle('is-open', open);
    toggle.setAttribute('aria-expanded', String(open));
  };

  async #handleUpsellChange(input) {
    const container = input.closest('[data-cart-subscription-upsell]');
    if (!container) return;

    const currentState = container.dataset.selectedState;
    const nextState = input.dataset.targetState;

    if (!nextState || currentState === nextState) return;

    const previousInput = container.querySelector(`[data-target-state="${currentState}"]`);
    this.#setLoading(container, true);

    try {
      const cartRes = await fetch('/cart.js', {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      });
      const cart = await cartRes.json();

      const lineKey = container.dataset.lineKey;
      const lineIndex = cart.items.findIndex((item) => item.key === lineKey);

      if (lineIndex === -1) throw new Error('Cart line not found');

      const activeItem = cart.items[lineIndex];
      const visibleProps = this.#getVisibleProperties(activeItem.properties);

      await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({ line: lineIndex + 1, quantity: 0 }),
      });

      const isUpgrade = nextState === 'subscription-upgraded';
      const nextVariantId = isUpgrade
        ? container.dataset.subscriptionVariantId
        : container.dataset.oneTimeVariantId;

      if (!nextVariantId) throw new Error('Variant ID not found');

      const nextProperties = isUpgrade
        ? { ...visibleProps, _upgraded_from: container.dataset.oneTimeProductHandle }
        : visibleProps;

      const addBody = {
        id: parseInt(nextVariantId, 10),
        quantity: parseInt(container.dataset.currentQuantity, 10) || 1,
        properties: nextProperties,
      };

      if (isUpgrade && container.dataset.subscriptionSellingPlanId) {
        addBody.selling_plan = parseInt(container.dataset.subscriptionSellingPlanId, 10);
      }

      await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify(addBody),
      });

      await this.#rerenderSection();
    } catch (err) {
      if (previousInput) previousInput.checked = true;
      input.checked = false;

      if (document.contains(container)) {
        this.#setLoading(container, false);
      }

      console.error('[cart-upsell]', err);
    }
  }

  async #rerenderSection() {
    const component = document.querySelector('cart-items-component');
    if (!component) return;

    const sectionId = component.dataset.sectionId;
    if (!sectionId) return;

    const res = await fetch(`${window.location.pathname}?section_id=${sectionId}`, {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    });
    const html = await res.text();

    component.insertAdjacentHTML('afterend', html);
    component.remove();
  }

  #getVisibleProperties(properties) {
    const result = {};
    if (!properties) return result;
    for (const [key, value] of Object.entries(properties)) {
      if (!key.startsWith('_') && value !== '' && value !== null) {
        result[key] = value;
      }
    }
    return result;
  }

  #setLoading(container, loading) {
    container.classList.toggle('is-upsell-loading', loading);
    container.querySelectorAll('[data-cart-upsell-input]').forEach((input) => {
      input.disabled = loading;
    });
  }
}

new CartSubscriptionUpsell();
